//Input: Array of purchaseOrderDetails
//Weight Total = Sum of (Qty*Unit Weight) on all items on the PO
// Cost Total = 
//        Sum (Qty*Weight*Price)  on all commodity items with unit type 'WT' 
//          + Sum (Qty*Price) on all commodity items with unit type 'CTN' 
//          + Sum (Qty*Price) on all burden items

// Case Total = Sum of Qty on all commodity items on the PO
// Pallets per Item = Qty/(Ti*Hi) on the item
// Pallets Total = Sum of Pallets on PO



const calculatePurchaseOrderTotals = (purchaseOrders) => {
  
  purchaseOrders.forEach((purchaseOrder) => {
    //convert json to array of details
    purchaseOrder.poDetail = JSON.parse(purchaseOrder.poDetail);
    var totalCost=0;
    var totalWeight=0;
    var totalCases=0;
    var totalPallets=0;

    purchaseOrder.poDetail.forEach(function(item) {
      var quantity = (item.qty == null  ? item.originalQty : item.qty );
      var price = (item.price == null ? item.originalPrice : item.price );

      totalCost += (item.unitType === 'WT' ? quantity * item.unitWeight * price : quantity * price);
      totalWeight += ((item.unitType === 'WT' || item.unitType === 'CTN') ? quantity * item.unitWeight  : 0);
      totalCases += ((item.unitType === 'WT' || item.unitType === 'CTN') ? quantity  : 0);
      item.calculatedPallets = ((item.unitType === 'WT' || item.unitType === 'CTN') ? quantity/item.cartonPallet : 0);
        totalPallets += item.calculatedPallets;
    });

    purchaseOrder.calculatedCost=totalCost;
    purchaseOrder.calculatedWeight=totalWeight;
    purchaseOrder.calculatedCases=totalCases;
    purchaseOrder.calculatedPallets=totalPallets;
  });
  
  return;
};


export default calculatePurchaseOrderTotals;
export { calculatePurchaseOrderTotals};